import { useLocation } from "react-router-dom";
import queryString from "query-string";

/**
 * Custom hook to fetch query string params
 */
const useQuery = (): queryString.ParsedQuery<string> => {
  const location = useLocation();
  return queryString.parse(location.search);
};

export default useQuery;
